<template>
    <div class="result">
        <div class="result_head">
            <div>
                <img src="./../assets/imgs/checked_identify@2x.png" alt="" srcset="">
            </div>
            <div style="margin-top:2remfont-weight: 400;font-size:1.5rem;color: #555555;">
                您的VIP申请已提交成功！
            </div>
            <div style="margin-top:2remfont-weight: 400;font-size:1.3rem;color: #999999;">
                请及时关注邮箱通知
            </div>
        </div>
        <div class="result_footer">
             <img src="./../assets/imgs/logo@2x.png" alt="" srcset="" style="height:10rem;">
             <p style="font-weight: 400;font-size:1.3rem;color: #666666;">关注“国道数据”公众号</p>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
}
</script>
<style scoped>
.result{
    text-align: center;
}
.result_head{
    margin-top: 5rem;
    text-align: center;
}
.result_footer{
   margin-top: 20rem;
}
</style>


// WEBPACK FOOTER //
// src/components/result.vue